import type { AdminAudienceKind } from '@/api/types';
import { AudienceKind } from '@/api/generated';

/**
 * Renders a stored audience summary (kind + description + size) for tables
 * and detail views. The raw id list never reaches the client.
 */
export function describeAudience(
  kind: AdminAudienceKind | undefined,
  description: string | undefined,
  size: number | undefined,
): string {
  if (!kind || kind === AudienceKind.AUDIENCE_KIND_ALL) {
    return 'All users';
  }
  if (description) {
    return description;
  }
  if (size !== undefined) {
    return `${size} selected ${size === 1 ? 'user' : 'users'}`;
  }
  return 'Selected users';
}
